import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static get values() {
        return {
            open: Boolean,
            hasChildren: Boolean,
            isHidden: Boolean,
        }
    }

    connect() {
        this.element.classList.add('expandable-childs', 'initial');
        this.element.setAttribute('data-expandable-childs-open-value', false);
        this.element.setAttribute('data-action', 'click->expandable-childs#toggle:capture');
        this.hasChildrenValue =  this.element.classList.contains('page_item_has_children');
    }

    toggle() {
        if (!this.hasChildrenValue) {
            return null;
        }

        if(!this.openValue) {
            this.openValue = true;
            this.element.classList.add('open');
            this.element.classList.remove('initial');
            this.element.classList.remove('close');
        } else {
            this.openValue = false;
            this.element.classList.add('close');
            this.element.classList.remove('open');
        }
    }
}
